// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1265":"9dc0b608","5996":"6e7feab4"}[chunkId] + ".chunk.css";
};